import { ChangeDetectorRef, Component } from '@angular/core';

import { DeviceDetectorService } from 'ngx-device-detector';

import { AdsBase } from '../ads.base';


@Component({
    selector: 'app-ads[desktop-header]',
    templateUrl: './desktop-header.component.html',
    styleUrls: ['./desktop-header.component.scss'],
})
export class AdsDesktopHeaderComponent extends AdsBase {
    public constructor(public deviceService: DeviceDetectorService, protected ref: ChangeDetectorRef) {
        super(deviceService, ref);
    }
}
